import { Header } from "../components/head";
import { Footer } from "../components/footer";

export default function Contact() {
  const styles = {
    page: {
      background: 'linear-gradient(180deg, #0b0e14 0%, #0f1420 100%)',
      minHeight: '100vh',
      color: '#e6eef7'
    },
    container: {
      maxWidth: 1100,
      margin: '0 auto',
      padding: '24px 16px'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: 16
    },
    card: {
      background: 'rgba(255,255,255,0.04)',
      border: '1px solid rgba(255,255,255,0.08)',
      borderRadius: 12,
      padding: 16,
      boxShadow: '0 10px 30px rgba(0,0,0,0.25)'
    },
    title: { margin: '8px 0 16px', fontSize: 28, fontWeight: 800, textAlign: 'center' },
    input: {
      width: '100%',
      padding: '10px 12px',
      background: 'rgba(255,255,255,0.06)',
      border: '1px solid rgba(255,255,255,0.12)',
      borderRadius: 8,
      color: '#e6eef7'
    },
    label: { fontSize: 13, marginBottom: 6, display: 'block', opacity: 0.9 },
    row: { display: 'grid', gridTemplateColumns: '1fr', gap: 12 },
    submit: {
      background: 'linear-gradient(135deg, #4a90e2 0%, #357abd 100%)',
      color: '#fff',
      fontWeight: 800,
      borderRadius: 10,
      padding: '10px 18px',
      border: '1px solid #5ba0f2',
      cursor: 'pointer',
      boxShadow: '0 6px 16px rgba(74,144,226,0.35)'
    },
    infoItem: { marginBottom: 10, lineHeight: 1.5 },
    link: { color: '#67b8ff', textDecoration: 'none' }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const name = form.name.value;
    const email = form.email.value;
    const subject = form.subject.value;
    const message = form.message.value;
    const mailto = `mailto:athumanzathuman@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(`From: ${name} <${email}>\n+
${message}`)}`;
    window.location.href = mailto;
  };

  return (
    <>
      <Header contactPg ={true}/>
      <div style={styles.page}>
        <div style={styles.container}>
          <h1 style={styles.title}>Contact Us</h1>
          <div style={styles.grid}>
            <div style={styles.card}>
              <form onSubmit={handleSubmit}>
                <div style={styles.row}>
                  <div>
                    <label style={styles.label}>Your Name</label>
                    <input style={styles.input} type="text" name="name" required maxLength={100} placeholder="Enter your full name" />
                  </div>
                  <div>
                    <label style={styles.label}>Your Email</label>
                    <input style={styles.input} type="email" name="email" required placeholder="email@example.com" />
                  </div>
                </div>
                <div style={{ height: 12 }}></div>
                <div>
                  <label style={styles.label}>Subject</label>
                  <input style={styles.input} type="text" name="subject" required maxLength={140} placeholder="How can we help?" />
                </div>
                <div style={{ height: 12 }}></div>
                <div>
                  <label style={styles.label}>Message</label>
                  <textarea style={{ ...styles.input, minHeight: 120, resize: 'vertical' }} name="message" required placeholder="Write your message here..." />
                </div>
                <div style={{ height: 14 }}></div>
                <button type="submit" style={styles.submit}>Send Message</button>
              </form>
            </div>
            <div style={styles.card}>
              <h3 style={{ marginTop: 0 }}>Reach us directly</h3>
              <p style={styles.infoItem}>Email: <a href="mailto:athumanzathuman@gmail.com" style={styles.link}>athumanzathuman@gmail.com</a></p>
              <p style={styles.infoItem}>WhatsApp: <a href="https://wa.me/+8619572907062" target="_blank" rel="noopener noreferrer" style={styles.link}>+86 195 7290 7062</a></p>
              <p style={styles.infoItem}>Office Hours: Mon - Fri, 9:00 - 18:00 (GMT+8)</p>
              <p style={{ ...styles.infoItem, opacity: 0.85 }}>We typically reply within 24 hours. For application inquiries, include your full name and the program you’re interested in.</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}


